<div class="overlay" (mousedown)="onBackdrop($event)">
  <div class="dialog" role="dialog" aria-modal="true" aria-labelledby="edit-title">
    <header>
      <h3 id="edit-title">Edit schedule</h3>
      <button type="button" class="x" aria-label="Close" [disabled]="saving" (click)="close()">&times;</button>
    </header>

    <div class="body">
      <p class="sub">{{ form.schedule_id }} &middot; times are in {{ form.timezone }}</p>

      <div class="row2">
        <label class="field">
          <span>Window start</span>
          <input #firstField type="datetime-local" [value]="start" (input)="start = $any($event.target).value">
        </label>
        <label class="field">
          <span>Window end</span>
          <input type="datetime-local" [value]="end" (input)="end = $any($event.target).value">
        </label>
      </div>
      <p class="err" *ngIf="windowError">{{ windowError }}</p>

      <fieldset>
        <legend>Servers in this window (untick to remove)</legend>
        <label class="check" *ngFor="let s of form.servers">
          <input type="checkbox" [checked]="!removed.has(s.instance_id)"
            (change)="toggleServer(s.instance_id, $any($event.target).checked)">
          <span [class.removed]="removed.has(s.instance_id)">
            {{ s.name || s.instance_id }}
            <small>{{ s.instance_id }}</small>
          </span>
        </label>
      </fieldset>
      <p class="err" *ngIf="allRemoved">To remove every server, cancel the schedule instead.</p>

      <label class="field">
        <span>Reason for the change (required)</span>
        <textarea rows="3" maxlength="300" [value]="reason" (input)="reason = $any($event.target).value"
          placeholder="e.g. Moved a week; app-server-03 under migration"></textarea>
      </label>
    </div>

    <footer>
      <button type="button" class="btn-outline" [disabled]="saving" (click)="close()">Close</button>
      <button type="button" class="btn-primary" [disabled]="!canSave" (click)="submit()">
        {{ saving ? 'Saving\u2026' : 'Save changes' }}
      </button>
    </footer>
  </div>
</div>